import { ArrowRight, Sparkles } from "lucide-react";
import { WHATSAPP_URL } from "../lib/contact";
import { useReveal } from "../hooks/useReveal";

export const Hero = () => {
  const ref = useReveal();
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen pt-28 md:pt-32 pb-16 flex flex-col"
    >
      {/* Decorative element */}
      <div className="absolute top-1/3 right-[-12%] w-[55vw] h-[55vw] max-w-[720px] max-h-[720px] rounded-full bg-[#ca0013]/8 blur-3xl pointer-events-none" />
      <div className="absolute bottom-10 left-[-10%] w-[40vw] h-[40vw] max-w-[520px] max-h-[520px] rounded-full bg-[#ca0013]/5 blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 w-full flex-1 flex flex-col justify-center">
        <div ref={ref} className="reveal">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-10 h-px bg-[#ca0013]" />
            <span
              data-testid="hero-eyebrow"
              className="font-label text-xs text-[#ca0013]"
            >
              Agencia de Marketing Digital
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-display text-5xl sm:text-7xl lg:text-[8.5rem] tracking-tighter leading-[0.92] text-[#111] max-w-[15ch]"
          >
            Construimos{" "}
            <span className="font-editorial text-[#ca0013] font-normal">
              marcas
            </span>
            <br />
            que la gente{" "}
            <span className="font-editorial text-[#ca0013] font-normal">
              recuerda
            </span>
            <span className="text-[#ca0013] blink">.</span>
          </h1>

          <div className="mt-10 md:mt-14 flex flex-col md:flex-row md:items-end md:justify-between gap-10">
            <p
              data-testid="hero-subtitle"
              className="font-body text-base md:text-lg text-[#4a4a4a] max-w-xl leading-relaxed"
            >
              Estrategia, contenido y diseño para que tu negocio deje de ser uno
              más en el feed. Convertimos seguidores en clientes con un sistema
              de marketing claro y medible.
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-5">
              <a
                data-testid="hero-cta-whatsapp"
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary group inline-flex items-center gap-3 bg-[#ca0013] hover:bg-[#a80010] text-white font-bold px-7 py-4 rounded-full transition-colors font-body text-sm md:text-base"
              >
                <Sparkles size={18} className="opacity-90" />
                Analizamos tu negocio sin costo
                <ArrowRight size={18} className="btn-arrow" />
              </a>
              <a
                data-testid="hero-cta-services"
                href="#que-hacemos"
                className="inline-flex items-center gap-2 font-body text-sm font-bold text-[#111] border-b border-[#111] pb-1 hover:text-[#ca0013] hover:border-[#ca0013] transition-colors"
              >
                Ver lo que hacemos
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div className="relative mt-16 md:mt-24 overflow-hidden border-y border-black/15 py-5 bg-[#ca0013] text-[#eeede9]">
        <div className="flex animate-marquee whitespace-nowrap">
          {Array.from({ length: 2 }).map((_, group) => (
            <div key={group} className="flex items-center shrink-0">
              {[
                "Redes Sociales",
                "Fotografía",
                "Video Profesional",
                "Branding",
                "Identidad Visual",
                "Marketing Digital",
                "Ads",
                "Estrategia",
              ].map((t, i) => (
                <span
                  key={`${group}-${i}`}
                  className="flex items-center gap-6 px-6"
                >
                  <span className="font-editorial text-3xl md:text-4xl">
                    {t}
                  </span>
                  <span className="w-2 h-2 rounded-full bg-[#eeede9]" />
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
